import {
  CalendarIcon,
  ChartPieIcon,
  DocumentDuplicateIcon,
  FolderIcon,
  HomeIcon,
  CurrencyDollarIcon,
  ChatBubbleBottomCenterTextIcon,
  VideoCameraSlashIcon,
  KeyIcon,
  UsersIcon,
  AdjustmentsHorizontalIcon,
  UserPlusIcon,
  PencilSquareIcon,
  ArrowPathIcon 
} from "@heroicons/react/24/outline";
import { useState } from "react";
import UserAccess from "./UserAccess";
const people = [
   
  {
    name: 'User Access',
    role: 'Grant users access to pages in Solidarity hub',
    icon: UserPlusIcon
  },
  
  
]
export default function PaymentRequestsAdmin() {

  const [userAccessSelected, setUserAccessSelected] = useState(false);
return (
  <>
    {!userAccessSelected ? (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {people.map((person) => {
          const Icon = person.icon; // get the icon component
          return (
            <div
              onClick={() => setUserAccessSelected(true)}
              key={person.email}
              className="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-indigo-600 hover:border-gray-400 cursor-pointer"
            >
              <div className="shrink-0">
                <Icon className="h-6 w-6 text-green-500" aria-hidden="true" />
              </div>
              <div className="min-w-0 flex-1">
                <span aria-hidden="true" className="absolute inset-0" />
                <p className="text-sm font-medium text-gray-900">{person.name}</p>
                <p className="truncate text-sm text-gray-500">{person.role}</p>
              </div>
            </div>
          );
        })}
      </div>
    ) : (
      <UserAccess />
    )}
  </>
);



}

